import { render, staticRenderFns } from "./CmsB2BGroupsOverviewTable.vue?vue&type=template&id=9b13f8a2&scoped=true"
import script from "./CmsB2BGroupsOverviewTable.vue?vue&type=script&lang=ts"
export * from "./CmsB2BGroupsOverviewTable.vue?vue&type=script&lang=ts"
import style0 from "./CmsB2BGroupsOverviewTable.vue?vue&type=style&index=0&id=9b13f8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b13f8a2",
  null
  
)

export default component.exports